<div *ngIf="show" class="fixed inset-0 z-50 overflow-y-auto bg-black/50 backdrop-blur-sm flex items-center justify-center p-4" (click)="close()">
  <div
    class="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] flex flex-col animate-scale-in"
    (click)="$event.stopPropagation()"
  >
    <div class="flex items-center justify-between p-6 pb-4">
      <h2 class="text-xl font-bold text-gray-900 dark:text-white">
        {{ formData.id ? 'Edit Product' : 'Add Product' }}
      </h2>
      <button
        (click)="close()"
        class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <div class="overflow-y-auto px-6">
      <form (ngSubmit)="save($event)" class="space-y-4">
      <!-- Product Type Selection -->
      <div class="mb-6 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg border-2 border-blue-200 dark:border-blue-800">
        <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3">
          Product Type *
        </label>
        <div class="flex flex-col sm:flex-row gap-3 sm:gap-4">
          <label [ngClass]="{
            'flex items-start sm:items-center cursor-pointer p-3 rounded-lg border-2 transition-all': true,
            'border-primary-500 bg-primary-50 dark:bg-primary-900/20': productType === 'normal',
            'border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-700/50': productType !== 'normal'
          }">
            <input
              type="radio"
              name="productType"
              [value]="'normal'"
              [(ngModel)]="productType"
              (ngModelChange)="onProductTypeChange($event)"
              class="w-4 h-4 text-primary-600 focus:ring-primary-500 mt-0.5 sm:mt-0 flex-shrink-0"
            />
            <div class="ml-3 flex-1">
              <div class="text-sm font-medium text-gray-700 dark:text-gray-300">
                Normal Product
              </div>
              <div class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                Single price, single stock
              </div>
            </div>
          </label>
          <label [ngClass]="{
            'flex items-start sm:items-center cursor-pointer p-3 rounded-lg border-2 transition-all': true,
            'border-primary-500 bg-primary-50 dark:bg-primary-900/20': productType === 'variant',
            'border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-700/50': productType !== 'variant',
            'opacity-60 cursor-not-allowed': !!(formData.id && formData.variants && formData.variants.length > 0)
          }">
            <input
              type="radio"
              name="productType"
              [value]="'variant'"
              [(ngModel)]="productType"
              (ngModelChange)="onProductTypeChange($event)"
              [disabled]="!!(formData.id && formData.variants && formData.variants.length > 0)"
              class="w-4 h-4 text-primary-600 focus:ring-primary-500 mt-0.5 sm:mt-0 flex-shrink-0"
            />
            <div class="ml-3 flex-1">
              <div class="text-sm font-medium text-gray-700 dark:text-gray-300">
                Variant Product
              </div>
              <div class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                Multiple sizes with different prices/stock
              </div>
            </div>
          </label>
        </div>
        <p class="text-xs text-gray-600 dark:text-gray-400 mt-2">
          💡 <strong>Normal:</strong> Set price and stock here. <strong>Variant:</strong> Set price and stock per variant after saving.
        </p>
        <p *ngIf="formData.id && formData.variants && formData.variants.length > 0" class="text-xs text-orange-600 dark:text-orange-400 mt-2">
          ⚠️ This product already has variants. Product type cannot be changed.
        </p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Product Name *
          </label>
          <input
            type="text"
            [(ngModel)]="formData.name"
            name="name"
            required
            class="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500"
          />
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Category *
          </label>
          <app-searchable-select
            [searchCallback]="categorySearchCallback"
            [pinnedOptions]="categoryPinnedOptions"
            [prefetchOnOpen]="true"
            [minSearchLength]="0"
            [searchPlaceholder]="'Search categories...'"
            [(ngModel)]="formData.category_id"
            [ngModelOptions]="{standalone: true}"
            [placeholder]="'Select Category'"
            (selectionChange)="onCategorySelect($event)"
          ></app-searchable-select>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            SKU
          </label>
          <input
            type="text"
            [(ngModel)]="formData.sku"
            name="sku"
            class="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500"
          />
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Barcode / QR Code
          </label>
          <div class="flex gap-2">
            <input
              type="text"
              [(ngModel)]="formData.barcode"
              (ngModelChange)="onBarcodeManualChange()"
              name="barcode"
              [placeholder]="isLoadingBarcode ? 'Generating barcode…' : 'Auto-generated if left empty'"
              [readonly]="isLoadingBarcode"
              maxlength="100"
              class="flex-1 px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500"
            />
            <button
              *ngIf="!formData.id"
              type="button"
              (click)="regenerateBarcode()"
              [disabled]="isLoadingBarcode || isSaving"
              class="px-3 py-2 rounded-lg border border-primary-200 dark:border-primary-700 text-primary-700 dark:text-primary-300 bg-primary-50 dark:bg-primary-900/20 hover:bg-primary-100 dark:hover:bg-primary-900/30 text-sm font-medium whitespace-nowrap disabled:opacity-50"
            >
              {{ isLoadingBarcode ? '…' : 'Regenerate' }}
            </button>
          </div>
          <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
            <span *ngIf="barcodeAutoSuggested && !formData.id">Next available sequential barcode (deleted numbers are not reused).</span>
            <span *ngIf="!barcodeAutoSuggested && !formData.id">Leave empty to auto-assign on save, or enter your own barcode.</span>
            <span *ngIf="formData.id">Unique per product. Used for billing scan.</span>
          </p>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Description
          </label>
          <input
            type="text"
            [(ngModel)]="formData.description"
            name="description"
            class="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500"
          />
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-4" *ngIf="productType === 'normal'">
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Purchase Rate (₹) *
          </label>
          <input
            type="number"
            [(ngModel)]="formData.cost"
            name="cost"
            step="0.01"
            min="0"
            [required]="productType === 'normal'"
            class="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500"
            placeholder="Purchase rate"
          />
          <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">Cost price</p>
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            MRP Rate (₹)
          </label>
          <input
            type="number"
            [(ngModel)]="formData.mrp"
            name="mrp"
            step="0.01"
            min="0"
            class="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500"
            placeholder="MRP (optional)"
          />
          <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">Maximum Retail Price</p>
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Sell Rate (₹) *
          </label>
          <input
            type="number"
            [(ngModel)]="formData.price"
            name="price"
            step="0.01"
            min="0"
            [required]="productType === 'normal'"
            class="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500"
            placeholder="Selling price"
          />
          <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">Selling price</p>
        </div>
      </div>

      <!-- GST Section -->
      <div class="border-t border-gray-200 dark:border-gray-700 pt-4 mt-4">
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">GST Information</h3>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              HSN Code
            </label>
            <input
              type="text"
              [(ngModel)]="formData.hsn_code"
              name="hsn_code"
              placeholder="e.g., 22029920"
              maxlength="20"
              class="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500"
            />
            <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
              HSN code for GST invoice (e.g., 22029920)
            </p>
          </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            GST Rate (%)
          </label>
          <input
            type="number"
            [(ngModel)]="formData.gst_rate"
            name="gst_rate"
            step="0.01"
            min="0"
            max="100"
            class="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500"
          />
            <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
              Common rates: 5%, 12%, 18%, 28%
            </p>
          </div>
        </div>

        <div class="mt-4">
          <label class="flex items-center">
            <input
              type="checkbox"
              [(ngModel)]="formData.has_gst"
              [ngModelOptions]="{standalone: true}"
              [checked]="formData.has_gst === 1"
              (change)="formData.has_gst = ($any($event.target).checked ? 1 : 0)"
              class="w-4 h-4 text-primary-600 rounded focus:ring-primary-500"
            />
            <span class="ml-2 text-sm text-gray-700 dark:text-gray-300">Apply GST</span>
          </label>
          <p class="text-xs text-gray-500 dark:text-gray-400 mt-1 ml-6">
            Enable GST for this product. HSN code is required for GST invoices.
          </p>
        </div>
      </div>

      <!-- Unit - Only for normal products -->
      <div *ngIf="productType === 'normal'">
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Unit
          <span *ngIf="isLoadingUnits" class="text-xs text-gray-500 dark:text-gray-400 ml-2">Loading...</span>
        </label>
        <app-searchable-select
          [options]="unitSelectOptions"
          [(ngModel)]="formData.unit"
          [ngModelOptions]="{standalone: true}"
          [placeholder]="'Select unit'"
          (selectionChange)="onUnitChange($event)"
        ></app-searchable-select>
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
          Quantity: {{ formData.unit_type === 'kg' ? 'Decimal allowed (weight)' : 'Whole numbers only' }}
        </p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4" *ngIf="productType === 'normal' && stockMaintenanceEnabled">
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Stock Quantity *
          </label>
          <input
            type="number"
            [(ngModel)]="formData.stock_quantity"
            name="stock_quantity"
            step="1"
            min="0"
            [required]="productType === 'normal' && stockMaintenanceEnabled"
            class="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500"
          />
          <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
            Unit: {{ formData.unit }}
          </p>
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Min Stock Level
          </label>
          <input
            type="number"
            [(ngModel)]="formData.min_stock_level"
            name="min_stock_level"
            step="1"
            min="0"
            class="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500"
          />
          <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
            Unit: {{ formData.unit }}
          </p>
        </div>
      </div>

      <div class="flex items-center">
        <input
          type="checkbox"
          [(ngModel)]="formData.is_active"
          [ngModelOptions]="{standalone: true}"
          [checked]="formData.is_active === 1"
          (change)="formData.is_active = ($any($event.target).checked ? 1 : 0)"
          id="is_active"
          class="w-4 h-4 text-primary-600 rounded focus:ring-primary-500"
        />
        <label for="is_active" class="ml-2 text-sm text-gray-700 dark:text-gray-300">
          Active
        </label>
      </div>

      <!-- Helper message for variant products -->
      <div *ngIf="productType === 'variant' && !formData.id" class="mb-4 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-800">
        <p class="text-sm text-blue-700 dark:text-blue-300">
          💡 <strong>After saving</strong>, go to Products page and click the "Variants" button to add variant sizes with their prices and stock quantities.
        </p>
      </div>

      <div class="flex justify-end space-x-3 pt-4">
        <button
          type="button"
          (click)="close()"
          class="px-3 py-1.5 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-lg text-sm font-semibold hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
        >
          Cancel
        </button>
        <button
          type="submit"
          [disabled]="isSaving"
          class="px-3 py-1.5 bg-primary-600 hover:bg-primary-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-white rounded-lg text-sm font-semibold transition-colors"
        >
          <span *ngIf="!isSaving">{{ formData.id ? 'Update' : 'Create' }}</span>
          <span *ngIf="isSaving" class="flex items-center">
            <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Saving...
          </span>
        </button>
      </div>
    </form>
    </div>
  </div>
</div>
